import "../../scss/pages/awards.scss";
import "bootstrap/js/dist/tab";
import axios from "axios";
import GlobalError from "../helpers/globalError";

export default class Awards {
	
	/**
	 *This function load the list of countries of a selected continent
	 * @param selectedContinent - string
	 */
	loadCountryList(selectedContinent) {
		const language = document.querySelector('#dropdownlanguageMenu');
		
		axios.post(`/${ language.dataset.languageSelected }/index/get-awards-by-continent`,
				
				{
					continent: selectedContinent,
					locale: language.dataset.languageSelected
				}
			)
			.then((response) => {
				const continentList = document.getElementById('container-btn-countries');
				continentList.innerHTML = response.data;
				
			})
			.catch(error => {
				if (error && error.response && error.response.data.errors) {
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalAwardsDetails');
				}
			})
	}
}

document.addEventListener("DOMContentLoaded", function () {
	
	const continentTabs = document.querySelectorAll('a[role="tab"]');
	
	continentTabs.forEach(continent => {
		continent.addEventListener('click', function () {
			const continentName = continent.dataset.continentName;
			
			const awardsModule = new Awards();
			awardsModule.loadCountryList(continentName);
		})
	})
});